<template>
  <a-drawer
    :title="title"
    :width="1024"
    :visible="isShow"
    :body-style="{ paddingBottom: '80px' }"
    @close="handleCancel"
  >
    <a-form-model ref="formDom" :model="form" :rules="rules" :label-col="{ span: 5 }" :wrapper-col="{ span: 21 }">
      <h3 class="cutline">通用信息</h3>
      <a-form-model-item label="地区">
        <a-cascader v-model="defaultCity" :options="cityOptions" placeholder="请选择" @change="onChangeCity" style="width: 240px;" />
      </a-form-model-item>
      <a-form-model-item label="地址">
        <a-input-search
          v-model="searchValue"
          :maxLength="100"
          placeholder="请输入地址"
          enter-button="查询"
          size="default"
          @search="onSearch"
          style="width: 240px;"
        />
      </a-form-model-item>
      <a-form-model-item label="地图定位">
        <div id="map-container" style="width: 100%; height: 360px"></div>
      </a-form-model-item>
      <a-form-model-item label="地址信息">
        <a-input v-model.trim="form.address" placeholder="请输入" style="width: 240px;" />
      </a-form-model-item>
      <a-form-model-item label="经度">
        <a-input :disabled="true" v-model.trim="form.longitude" placeholder="请输入" style="width: 240px;" />
      </a-form-model-item>
      <a-form-model-item label="纬度">
        <a-input :disabled="true" v-model.trim="form.latitude" placeholder="请输入" style="width: 240px;" />
      </a-form-model-item>
      <a-form-model-item label="电话">
        <a-input v-model.trim="form.phone" :maxLength="20" placeholder="请输入电话" style="width: 240px;" />
      </a-form-model-item>
      <a-form-model-item label="邮编">
        <a-input v-model.trim="form.zip_code" :maxLength="20" placeholder="请输入邮编" style="width: 240px;" />
      </a-form-model-item>
      <a-form-model-item label="邮箱">
        <a-input v-model.trim="form.email" :maxLength="20" placeholder="请输入邮箱" style="width: 240px;" />
      </a-form-model-item>
      <a-form-model-item label="公司图片:">
        <a-upload name="file" :headers="{ token }" :before-upload="beforeUpload" list-type="picture-card"
                  class="avatar-uploader" :show-upload-list="true" :action="`${baseURL}/public/upload-file-qi-niu`"
                  @change="(data) => handleChangeImg(data)" :file-list="fileList" @preview="preview">
          <div v-if="fileList.length < 1">
            <a-icon type="plus" />
            <div class="ant-upload-text">上传图片</div>
          </div>
        </a-upload>
        <span>1、仅支持png、jpg、jpeg格式图片上传<br>2、仅支持上传单张，单张图片不超过2M</span>
      </a-form-model-item>
      <a-form-model-item label="选择品牌">
        <a-checkbox :indeterminate="indeterminate" :checked="checkAll" @change="onCheckAllChange">全选</a-checkbox>
        <br>
        <a-checkbox-group v-model="checkedList" :options="plainOptions" @change="onChange">
          <span slot="label" slot-scope="{ value }">{{ value }}</span>
        </a-checkbox-group>
      </a-form-model-item>
      <h3 class="cutline">差异信息</h3>
      <a-tabs type="card">
        <a-tab-pane v-for="item in plainOptions.filter(v => checkedList.includes(v.value))" :key="item.value" :tab="item.label">
          <a-form-model-item label="分公司别称">
            <a-input v-model.trim="item.company_name" placeholder="请输入分公司别称" style="width: 240px;" />
          </a-form-model-item>
          <a-form-model-item label="其他电话" v-for="(phone, index) in item.phones" :key="phone.id">
            <a-input v-model.trim="phone.number" :maxLength="20" placeholder="请输入电话" style="width: 240px;" />
            <a-button v-if="index !== 0" type="danger" class="marginbtn" @click="removePhone(item, index)">移除</a-button>
            <a-button v-if="index === 0" type="primary" class="marginbtn" @click="addPhone(item)">添加电话</a-button>
          </a-form-model-item>
          <a-form-model-item label="差异邮箱" v-for="(email, index) in item.emails" :key="email.id">
            <a-input v-model.trim="email.number" :maxLength="20" placeholder="请输入邮箱" style="width: 240px;" />
            <a-button v-if="index !== 0" type="danger" class="marginbtn" @click="removeEmail(item, index)">移除</a-button>
            <a-button v-if="index === 0" type="primary" class="marginbtn" @click="addEmail(item)">添加邮箱</a-button>
          </a-form-model-item>
          <a-form-model-item label="公司图片:">
            <a-upload name="file" :headers="{ token }" :before-upload="beforeUpload" list-type="picture-card"
                      class="avatar-uploader" :show-upload-list="true" :action="`${baseURL}/public/upload-file-qi-niu`"
                      @change="(data) => handleChangeDiffImg(data, item)" :file-list="item.fileList" @preview="preview">
              <div v-if="item.fileList.length < 1">
                <a-icon type="plus" />
                <div class="ant-upload-text">上传图片</div>
              </div>
            </a-upload>
            <span>1、仅支持png、jpg、jpeg格式图片上传<br>2、仅支持上传单张，单张图片不超过2M</span>
          </a-form-model-item>
        </a-tab-pane>
      </a-tabs>
    </a-form-model>
    <div
      :style="{
        position: 'absolute',
        right: 0,
        bottom: 0,
        width: '100%',
        borderTop: '1px solid #e9e9e9',
        padding: '10px 16px',
        background: '#fff',
        textAlign: 'right',
        zIndex: 1,
      }"
    >
      <a-button key="back" style="margin-right: 20px" @click="handleCancel">取 消</a-button>
      <a-button key="submit" type="primary" :loading="btnloading" @click="handleSubmit">提 交</a-button>
    </div>
    <a-modal :visible="previewVisible" width="720px" :footer="null" @cancel="preViewCancel">
      <div class="preViewImg">
        <img alt="example" style="width: 100%" :src="previewImage" />
      </div>
    </a-modal>
  </a-drawer>
</template>
<script>
import { reactive, toRefs, getCurrentInstance, defineComponent, onMounted, watch, computed } from '@vue/composition-api'
import { form, rules } from '../business/filialeList'
import dialog from '@/composables/dialog'
import compuedFun from '../computed/'
import api from '@/api/'
import storeGlobal from '@/store/'
import token from '@/composables/token'

const title = {
  Add: '添加地址',
  Edit: '编辑地址',
}

export default defineComponent({
  mixins: [dialog],
  props: {
    platformList: {
      type: [Object, Array],
      default() {
        return {}
      },
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    params: {
      type: Object,
      default: null,
    },
  },
  setup(props, { root }) {
    const _this = getCurrentInstance()
    const state = reactive({
      rules,
      ...token(),
      title: title.Add,
      btnloading: false,
      principalList: [], // 负责人
      form: { ...form },
      fileList: [],
      baseURL: process.env.VUE_APP_API_BASE_URL,
      previewVisible: false,
      previewImage: '',
      checkedList: [],
      indeterminate: true,
      checkAll: false,
      plainOptions: [],
      cityOptions: [],
      map: null, // 地图实例
      mk: null, // Marker实例
      searchInfo: '',
      searchValue: '',
      defaultCity: []
    })
    const labels = computed(() => {
      return storeGlobal.state.label.data
    })

    watch(
      () => _this.params,
      async () => {
        state.form = JSON.parse(JSON.stringify(_this.params))
        state.form.area_id = state.form?.area_id ? Number(state.form.area_id) : undefined
        if (state.form.img) {
          state.fileList = [{
            uid: Date.now(),
            name: `${Date.now()}`,
            status: 'done',
            url: state.form.img
          }]
        }
        const responsible = state.form.responsible_name + '(' + state.form.responsible_number + ')'
        _this.$set(state.form, 'responsible', responsible)
      }
    )

    onMounted(async () => {
      state.title = _this.isEdit ? title.Edit : title.Add
      await methods.getCityList()
      await methods.getPlatform()
      methods.initMap()
    })

    const methods = {
      beforeUpload(file) {
        return new Promise((resolve, reject) => {
          const isJpgOrPng =
            file.type === 'image/jpeg' ||
            file.type === 'image/jpg' ||
            file.type === 'image/png'
          if (!isJpgOrPng) {
            this.$message.error('仅支持png、jpg、jpeg格式图片上传!')
            return reject(new Error(false))
          }
          const isLt2M = file.size / 1024 / 1024 <= 2
          if (!isLt2M) {
            this.$message.error('图片大小不超过 2MB!')
            return reject(new Error(false))
          }
          return resolve(true)
        })
      },
      handleChangeImg(data) {
        this.fileList = data.fileList
        this.form.img = data.fileList[0]?.response
            ? data.fileList[0].response.data.full_url
            : ''
      },
      handleChangeDiffImg(data, item) {
        item.fileList = data.fileList
        item.img = data.fileList[0]?.response
            ? data.fileList[0].response.data.full_url
            : ''
      },
      preview(file) {
        this.previewImage = file.url || this.labels.QI_NIU_DOMAINS + '/' + file.response.data.url
        this.previewVisible = true
      },
      preViewCancel() {
        this.previewVisible = false
      },
      handleSubmit() {
        state.btnloading = true
        _this.$refs.formDom.validate(async (valid) => {
          let res = null
          const data = { ...state.form, businessLines: state.plainOptions.filter(v => state.checkedList.includes(v.value)).map(val => {
            return {
              project: val.project,
              type: '0',
              staff_style: '0',
              company_name: val.company_name,
              phone: val.phones.map(v => v.number).filter(Boolean).join(','),
              email: val.emails.map(v => v.number).filter(Boolean).join(','),
              img: val.img
            }
          }) }
          // 验证手机号和座机号是否有一个输入
          if (valid) {
            if (!state.form.province || !state.searchValue || !state.form.address) {
              _this.$message.warning('地址信息不能为空')
              state.btnloading = false
              return
            }

            if (_this.isEdit) {
              res = await api.companyAddressUpdate(data)
            } else {
              res = await api.companyAddressCreate(data)
            }
            if (_this.$validate(res)) {
              this.$message.success(_this.isEdit ? '编辑成功~' : '添加成功~')
              _this.isShow = false
              state.btnloading = false
              state.form.phone = ''
              _this.$emit('handleOver')
            } else {
              state.btnloading = false
            }
          } else {
            this.$message.warning('请检查信息是否填写完成')
            state.btnloading = false
          }
        })
      },
      handleCancel() {
        _this.$refs.formDom.resetFields()
        state.form.phone = ''
        _this.isShow = false
        state.fileList = []
      },
      // 获取负责人
      async getStaffSearchList(value) {
        const res = await api.staffSearchList({ name: value })
        _this.principalList = res.data.staff
      },
      // 搜索
      fetchUser(value) {
        this.getStaffSearchList(value)
      },
      handleChange() {
        if (!_this.form.responsible) return
        let str = _this.form.responsible
        var name = str.split(/\(.*?\)/)[0]
        _this.form.responsible_name = name
        const re = /\([^)]+\)/g
        str = str.match(re)[0]
        str = str.substring(1, str.length - 1)
        _this.form.responsible_number = str
      },
      onChange() {
        state.indeterminate = state.checkedList.length && state.checkedList.length < state.plainOptions.length
        state.checkAll = state.plainOptions.length === state.checkedList.length
      },
      onCheckAllChange(e) {
        if (state.plainOptions.length === state.checkedList.length) {
          state.checkedList = []
          state.checkAll = false
          state.indeterminate = false
        } else {
          state.checkedList = state.plainOptions.map(val => val.value)
          state.checkAll = true
          state.indeterminate = false
        }
      },
      cityDiff(list) {
        for (const item of list) {
          item.value = item.id
          item.label = item.name
          if (item?.children?.length > 0) {
            item.children = this.cityDiff(item.children)
          }
        }
        return list
      },
      async getCityList() {
        const res = await api.getCityList({
          is_tree: "1"
        })
        state.cityOptions = this.cityDiff(res.data)
      },
      async getPlatform() {
        const res = await api.LineListNew()
        state.plainOptions = res.data.filter(item => {
          if (item.parent_id === 0) {
            return item
          }
        }).map(item => {
          const oldData = props?.params?.businessLines?.find?.(v => Number(v.project) === Number(item.project)) || {}
          return {
            ...item,
            label: item.name,
            value: item.project,
            project: item.project,
            type: '0',
            staff_style: '0',
            company_name: oldData.company_name || '',
            phone: oldData.phone || '',
            email: oldData.email || '',
            img: oldData.img || '',
            fileList: oldData.img ? [{
              uid: Date.now(),
              name: `${Date.now()}`,
              status: 'done',
              url: oldData.img
            }] : [],
            phones: oldData.phone ? oldData.phone.split(',').map((v, index) => {
              return {
                id: Date.now() + '' + index,
                number: v
              }
            }) : [{ id: Date.now(), number: '' }],
            emails: oldData.email ? oldData.email.split(',').map((v, index) => {
              return {
                id: methods.generateRandomId() + '' + index,
                number: v
              }
            }) : [{ id: methods.generateRandomId(), number: '' }]
          }
        })
        if (props.params) {
          state.checkedList = props?.params?.businessLines?.map?.(v => Number(v.project))
          state.searchValue = state.form.address
          state.defaultCity = [Number(props?.params?.province_id), Number(props?.params?.city_id), Number(props?.params?.area_id)]
        } else {
          state.checkedList = state.plainOptions.length > 0 ? [state.plainOptions[0].value] : []
        }
      },
      onChangeCity(value, label) {
        state.form.province_id = value[0] || ''
        state.form.province = label ? label[0].name : ''
        state.form.city_id = value[1] || ''
        state.form.city = label ? label[1].name : ''
        state.form.area_id = value[2] || ''
        state.form.area = label ? label[2].name : ''
      },
      onSearch(str) {
        state.searchInfo = str
        if (state.form.province && str) {
          var local = new window.BMap.LocalSearch(state.map, {
            onSearchComplete: (result) => {
              state.map.centerAndZoom(result.getPoi(0).point, 16)
              for (var i = 0; i < result.Wr.length; i++) {
                const mk = new window.BMap.Marker(result.Wr[i].point, { enableDragging: true })
                state.map.addOverlay(mk)
              }
            }
          })
          local.search(state.form.province + state.form.city + state.form.area + str)
        } else {
          _this.$message.warning('请输入地区和地址再查询~')
        }
      },
      // 百度地图封装方法
      // 初始化地图
      initMap() {
        try {
          // 1、挂载地图
          // 创建地图实例
          state.map = new window.BMap.Map('map-container')
          // 设置中心经纬度  这里我们使用BMapGL命名空间下的Point类来创建一个坐标点。Point类描述了一个地理坐标点，其中120.872845表示经度，32.021089表示纬度。（为南通濠河风景区坐标） 作者：星银色飞行船
          var point = new window.BMap.Point(104.09014, 30.654382)
          // 3.在创建地图实例后，我们需要对其进行初始化，BMapGL.Map.centerAndZoom()方法要求设置中心点坐标和地图级别。 地图必须经过初始化才可以执行其他操作
          state.map.centerAndZoom(point, 16)
          // 滚轮缩放
          state.map.enableScrollWheelZoom()
          // 3、设置图像标注并绑定拖拽标注结束后事件
          state.mk = new window.BMap.Marker(point, { enableDragging: true })
          state.map.addOverlay(state.mk)
        } catch (err) {
          return false
        }
        // 4、添加（右上角）平移缩放控件
        state.map.addControl(
          new window.BMap.NavigationControl({
            anchor: window.BMAP_ANCHOR_TOP_RIGHT,
            type: window.BMAP_NAVIGATION_CONTROL_SMALL
          })
        )
        // 7、绑定点击地图任意点事件
        state.map.addEventListener('click', function (e) {
          if (!state.form.province || !state.searchValue) {
            _this.$message.warning('请输入完整的地区和地址再操作~')
            return
          }
          if (state.searchInfo !== state.searchValue) {
            _this.$message.warning('请点击查询按钮再操作~')
            return
          }
          methods.getAddrByPoint(e.point)
        })
        return true
      },
      // 2、逆地址解析函数 根据坐标点获取详细地址  point   百度地图坐标点，必传
      getAddrByPoint(point) {
        var geco = new window.BMap.Geocoder()
        geco.getLocation(point, function (res) {
          // console.log(res);
          state.mk.setPosition(point)
          state.map.panTo(point)
          state.form.address = res.address
          state.form.longitude = String(res.point.lng)
          state.form.latitude = String(res.point.lat)
        })
      },
      addPhone(item) {
        if (item.phones.length > 4) {
          _this.$message.warning('最多只能添加5条~')
          return
        }
        item.phones.push({ id: Date.now(), number: '' })
      },
      removePhone(item, index) {
        if (item.phones.length !== 1) {
          item.phones.splice(index, 1)
        }
      },
      addEmail(item) {
        if (item.emails.length > 4) {
          _this.$message.warning('最多只能添加5条~')
          return
        }
        item.emails.push({ id: methods.generateRandomId(), number: '' })
      },
      removeEmail(item, index) {
        if (item.emails.length !== 1) {
          item.emails.splice(index, 1)
        }
      },
      generateRandomId() {
        return Math.random().toString(36).substr(2, 9)
      }
    }
    return {
      ...toRefs(state),
      ...compuedFun(),
      ...methods,
      labels
    }
  },
})
</script>
<style scoped lang="less">
.conter {
  // 去除百度地图的图标
  ::v-deep .anchorBL {
    display: none !important;
  }
}
.preViewImg {
  padding: 10px 20px;
}
.cutline {
  font-weight: bold;
  font-size: 16px;
  line-height: 24px;
  padding-left: 13px;
  position: relative;

  &::after {
    content: "";
    display: block;
    width: 5px;
    height: 16px;
    background: #1890ff;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    margin: auto;
  }
}
.marginbtn {
  margin-left: 6px;
  padding: 0 8px;
}
/deep/.ant-form-item {
  margin-bottom: 16px;
}
/deep/.ant-form-item-label {
  width: 90px;
}
/deep/.ant-checkbox-wrapper {
  width: 98px;
  margin-right: 0;
}
</style>
